<template>
  <v-app>
    <v-content>
      <v-container fluid grid-list-xl >
        <v-layout row wrap>
          <v-flex xs12 lg6>
            <Article/>
          </v-flex>
          <v-flex xs12 lg6>
            <Images/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Article from './components/Article'
import Images from './components/Images'

export default {
  name: 'App',
  components: {
    Article,
    Images
  },
  data () {
    return {}
  }
}
</script>

<style>
    @import 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons';
</style>